<template>
  <div :class="['bg-white border border-neutral-100 rounded-lg-custom p-4 sm:p-6', attrs.class]">
    <h2 v-if="title" :class="['col-span-full text-lg sm:text-xl font-bold text-neutral-850', { 'mb-4': !subtitle }]">{{ title }}</h2>
    <p v-if="subtitle" class="col-span-full text-sm text-neutral-600 mb-4">{{ subtitle }}</p>

    <slot />
  </div>
</template>

<script setup>
import { sub } from 'date-fns';
import { useAttrs } from 'vue';

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

defineProps({
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  }
});
</script>